"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _I18n = _interopRequireDefault(require("I18n"));

var _immutable = require("immutable");

var _TimezoneGroups = _interopRequireDefault(require("../lists/TimezoneGroups"));

var _TimezoneBlacklist = _interopRequireDefault(require("../lists/TimezoneBlacklist"));

var _TimezoneGroup = _interopRequireDefault(require("../records/TimezoneGroup"));

var _Timezone = _interopRequireDefault(require("../records/Timezone"));

var MAX_CITIES_IN_GROUP_NAME = 4;

var _default = function _default(timezoneAliases) {
  return new _TimezoneGroups.default((0, _immutable.List)(_I18n.default.moment.tz.names()).filter(function (name) {
    return name.search(/GMT/g) < 0 && name.search(/Etc/g) < 0 && name.search(/\//g) > -1 && !_TimezoneBlacklist.default.includes(name);
  }).groupBy(function (name) {
    return name.split('/')[0];
  }).map(function (timezonesByArea, area) {
    return new _TimezoneGroup.default({
      groupName: _I18n.default.text("timezone_utils.regions." + area.toLowerCase()),
      timezones: timezonesByArea.groupBy(function (timezoneName) {
        var momentTimezone = _I18n.default.moment.tz.zone(timezoneName);

        var untils = new _immutable.List(momentTimezone.untils);
        var offsets = new _immutable.List(momentTimezone.offsets);
        var futureTransitions = untils.filter(function (until) {
          return until > _I18n.default.moment().valueOf();
        });
        var futureOffsets = offsets.takeLast(futureTransitions.size);
        return futureTransitions.filter(function (transition) {
          return transition !== Infinity;
        }).concat(futureOffsets).hashCode();
      }).toList().map(function (momentTimezones) {
        var aliasWithTimezoneInGroup = function aliasWithTimezoneInGroup(alias) {
          return alias.timezones.some(function (timezone) {
            return momentTimezones.includes(timezone);
          });
        };

        var alias = timezoneAliases.find(aliasWithTimezoneInGroup);
        var cityNames = momentTimezones.map(function (timezone) {
          return timezone.split('/').pop().toLowerCase();
        }).toArray();

        var offset = _I18n.default.moment.tz(momentTimezones.first()).format('Z');

        var translatedCityNames = cityNames.map(function (name) {
          return _I18n.default.text("timezone_utils.cities." + name);
        });
        var name = alias ? alias.name : _I18n.default.formatList(translatedCityNames.slice(0, MAX_CITIES_IN_GROUP_NAME));
        return new _Timezone.default({
          offset: offset,
          momentTimezones: momentTimezones,
          name: name
        });
      })
    });
  }).toList());
};

exports.default = _default;
module.exports = exports.default;